A question search result.
